<template>
  <div class="nitrogen-legend legend">
    <div
      class="color"
      v-for="(color, i) in meta.amount"
    >
      <div
        class="square"
        :style="{ backgroundColor : colors[i] }"
      ></div>
      <div class="description">
        <p>
          <span class="text">
            {{$ml.get('Total Nitrogen per zone')}} :
          </span>
          <b>
            {{color.amount.toFixed(2)}}
          </b>
        </p>
        <p>
          <span class="text">
            {{$ml.get('Average amount of Nitrogen in the zone')}} :
          </span>
          <b>
            {{color.nitrogenValue != 'NaN' ? `${color.nitrogenValue.toFixed(2)} ${color.nitrogenValueUnit}` : '-'}}
          </b>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      colors : ['#ccffff', '#1affff', '#1aa3ff', '#0000ff', '#000066']
    }
  },
  created() {
    console.log(this.meta);
  },
  computed: {
    ...mapGetters({
      meta: 'satellite/nitrogenMeta',
    })
  },
  destroy() {
    this.$store.commit('satellite/saveColorData', null);
  }
}
</script>

<style lang="scss" scoped>
.legend {
  margin-top: 16px;
  .color {
    margin-bottom: 4px;
    padding-bottom: 4px;
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    .square {
      width: 80px;
      height: 80px;
      flex-basis: 20%;
    }
    .description {
      // flex-grow: 1;
      padding-left: 8px;
      p {
        margin-top: 0;
        margin-bottom: 4px;
        display: flex;
        flex-direction: column;
        span {
          font-size: 13px;
          white-space: nowrap;
        }
      }
    }

  }
}
</style>
